import Swal from "sweetalert2/dist/sweetalert2.js";
import i18n from "@/core/plugins/i18n";
import { processErrorMessage } from "@/core/types/ErrorMessage";
const t = i18n.global.t;

// 设置最高层级 z-index
const ensureTopLevel = (popup: HTMLElement) => {
  if (popup && popup.parentElement) {
    popup.parentElement.style.zIndex = "99999";
    popup.parentElement.style.position = "relative";
    // 确保覆盖层也有正确的 z-index
    const overlay = document.querySelector(".swal2-container");
    if (overlay) {
      (overlay as HTMLElement).style.zIndex = "99999";
      (overlay as HTMLElement).style.position = "fixed";
    }
    // 额外确保弹窗本身的 z-index
    popup.style.zIndex = "99999";
    popup.style.position = "relative";
  }
};

export default {
  success: (
    _text = t("tip.submitSuccess"),
    _title = "",
    _confirmButtonText = "OK",
    _confirmButton = "btn fw-semobold btn-light-primary"
  ) =>
    Swal.fire({
      title: _title,
      text: _text,
      icon: "success",
      buttonsStyling: false,
      confirmButtonText: _confirmButtonText,
      customClass: {
        confirmButton: _confirmButton,
        container: "my-swal-overlay",
      },
      onOpen: ensureTopLevel,
    }),

  info: (
    _text = t("title.info"),
    _title = "Title",
    _confirmButtonText = "OK",
    _confirmButton = "btn fw-semobold btn-light-info"
  ) =>
    Swal.fire({
      title: _title,
      text: _text,
      icon: "info",
      buttonsStyling: false,
      showCloseButton: true,
      confirmButtonText: _confirmButtonText,
      customClass: {
        confirmButton: _confirmButton,
        container: "my-swal-overlay",
      },
      onOpen: ensureTopLevel,
    }),

  warning: (
    _text = t("tip.pleaseTryAgain"),
    _title = "",
    _confirmButtonText = "OK",
    _confirmButton = "btn fw-semobold btn-light-warning",
    _textAlign = "center"
  ) =>
    Swal.fire({
      title: _title,
      text: _text,
      icon: "warning",
      buttonsStyling: false,
      confirmButtonText: _confirmButtonText,
      customClass: {
        confirmButton: _confirmButton,
        container: "my-swal-overlay",
        content: _textAlign === "justify" ? "text-justify" : "",
      },
      onOpen: ensureTopLevel,
    }),

  error: (
    _text,
    _title = "",
    _confirmButtonText = "OK",
    _confirmButton = "btn fw-semobold btn-light-danger"
  ) => {
    // let statusCode = "";
    _text = processErrorMessage(_text);
    // Add a tighter spacing class for title/content to reduce gap
    return Swal.fire({
      title: _title,
      text: _text,
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: _confirmButtonText,
      customClass: {
        confirmButton: _confirmButton,
        container: "my-swal-overlay",
        title: "swal2-title-tight",
        content: "swal2-content-tight",
      },
      onOpen: (popup) => {
        // ensure z-index and also inject style once
        ensureTopLevel(popup as HTMLElement);
        if (!document.getElementById("swal-tight-style")) {
          const style = document.createElement("style");
          style.id = "swal-tight-style";
          style.innerHTML = `
            .swal2-title-tight { margin-bottom: 6px !important; }
            .swal2-content-tight { margin-top: 2px !important; }
          `;
          document.head.appendChild(style);
        }
      },
    });
  },

  errorMsgOnly: (
    _text,
    _title = "",
    _confirmButtonText = "OK",
    _confirmButton = "btn fw-semobold btn-light-danger"
  ) => {
    // let statusCode = "";

    return Swal.fire({
      title: _title,
      text: _text,
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: _confirmButtonText,
      customClass: {
        confirmButton: _confirmButton,
        container: "my-swal-overlay",
      },
      onOpen: ensureTopLevel,
    });
  },
};
